// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gc8Y","delete":"styles_delete__psBh7","update":"styles_update__2HyKq","add":"styles_add__2mAs7"};